export default function stopBodyScrolling(bool) {
    window.addEventListener('scroll', () => {
        document.documentElement.style.setProperty(
            '--scroll-y',
            `${window.scrollY}px`,
        );
    });
    if (bool === true) {
        const scrollY = document.documentElement.style.getPropertyValue(
            '--scroll-y',
        );
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}`;
    } else {
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        // eslint-disable-next-line radix
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
}
